export const MAT_ICONS = [
  {matClass: '3d_rotation'},
  {matClass: 'accessibility'},
  {matClass: 'accessibility_new'},
  {matClass: 'accessible'},
  {matClass: 'accessible_forward'},
  {matClass: 'account_balance'},
  {matClass: 'account_balance_wallet'},
  {matClass: 'account_box'},
  {matClass: 'account_circle'},
  {matClass: 'add_shopping_cart'},
  {matClass: 'alarm'},
  {matClass: 'alarm_add'},
  {matClass: 'alarm_off'},
  {matClass: 'alarm_on'},
  {matClass: 'all_out'},
  {matClass: 'android'},
  {matClass: 'announcement'},
  {matClass: 'arrow_right_alt'},
  {matClass: 'aspect_ratio'},
  {matClass: 'assessment'},
  {matClass: 'assignment'},
  {matClass: 'assignment_ind'},
  {matClass: 'assignment_late'},
  {matClass: 'assignment_return'},
  {matClass: 'assignment_returned'},
  {matClass: 'assignment_turned_in'},
  {matClass: 'autorenew'},
  {matClass: 'backup'},
  {matClass: 'book'},
  {matClass: 'bookmark'},
  {matClass: 'bookmark_border'},
  {matClass: 'bug_report'},
  {matClass: 'build'},
  {matClass: 'cached'},
  {matClass: 'calendar_today'},
  {matClass: 'calendar_view_day'},
  {matClass: 'camera_enhance'},
  {matClass: 'card_giftcard'},
  {matClass: 'card_membership'},
  {matClass: 'card_travel'},
  {matClass: 'change_history'},
  {matClass: 'check_circle'},
  {matClass: 'check_circle_outline'},
  {matClass: 'chrome_reader_mode'},
  {matClass: 'class'},
  {matClass: 'code'},
  {matClass: 'commute'},
  {matClass: 'compare_arrows'},
  {matClass: 'contact_support'},
  {matClass: 'copyright'},
  {matClass: 'credit_card'},
  {matClass: 'dashboard'},
  {matClass: 'date_range'},
  {matClass: 'delete'},
  {matClass: 'delete_forever'},
  {matClass: 'delete_outline'},
  {matClass: 'description'},
  {matClass: 'dns'},
  {matClass: 'done'},
  {matClass: 'done_all'},
  {matClass: 'done_outline'},
  {matClass: 'donut_large'},
  {matClass: 'donut_small'},
  {matClass: 'drag_indicator'},
  {matClass: 'eject'},
  {matClass: 'euro_symbol'},
  {matClass: 'event'},
  {matClass: 'event_seat'},
  {matClass: 'exit_to_app'},
  {matClass: 'explore'},
  {matClass: 'extension'},
  {matClass: 'face'},
  {matClass: 'favorite'},
  {matClass: 'favorite_border'},
  {matClass: 'feedback'},
  {matClass: 'find_in_page'},
  {matClass: 'find_replace'},
  {matClass: 'fingerprint'},
  {matClass: 'flight_land'},
  {matClass: 'flight_takeoff'},
  {matClass: 'flip_to_back'},
  {matClass: 'flip_to_front'},
  {matClass: 'g_translate'},
  {matClass: 'gavel'},
  {matClass: 'get_app'},
  {matClass: 'gif'},
  {matClass: 'grade'},
  {matClass: 'group_work'},
  {matClass: 'help'},
  {matClass: 'help_outline'},
  {matClass: 'highlight_off'},
  {matClass: 'history'},
  {matClass: 'home'},
  {matClass: 'horizontal_split'},
  {matClass: 'hourglass_empty'},
  {matClass: 'hourglass_full'},
  {matClass: 'http'},
  {matClass: 'https'},
  {matClass: 'important_devices'},
  {matClass: 'info'},
  {matClass: 'input'},
  {matClass: 'invert_colors'},
  {matClass: 'label'},
  {matClass: 'label_important'},
  {matClass: 'language'},
  {matClass: 'launch'},
  {matClass: 'line_style'},
  {matClass: 'line_weight'},
  {matClass: 'list'},
  {matClass: 'lock'},
  {matClass: 'lock_open'},
  {matClass: 'loyalty'},
  {matClass: 'markunread_mailbox'},
  {matClass: 'maximize'},
  {matClass: 'minimize'},
  {matClass: 'motorcycle'},
  {matClass: 'note_add'},
  {matClass: 'offline_bolt'},
  {matClass: 'offline_pin'},
  {matClass: 'opacity'},
  {matClass: 'open_in_browser'},
  {matClass: 'open_in_new'},
  {matClass: 'open_with'},
  {matClass: 'pageview'},
  {matClass: 'pan_tool'},
  {matClass: 'payment'},
  {matClass: 'perm_camera_mic'},
  {matClass: 'perm_contact_calendar'},
  {matClass: 'perm_data_setting'},
  {matClass: 'perm_device_information'},
  {matClass: 'perm_identity'},
  {matClass: 'perm_media'},
  {matClass: 'perm_phone_msg'},
  {matClass: 'perm_scan_wifi'},
  {matClass: 'pets'},
  {matClass: 'picture_in_picture'},
  {matClass: 'picture_in_picture_alt'},
  {matClass: 'play_for_work'},
  {matClass: 'polymer'},
  {matClass: 'power_settings_new'},
  {matClass: 'pregnant_woman'},
  {matClass: 'print'},
  {matClass: 'query_builder'},
  {matClass: 'question_answer'},
  {matClass: 'receipt'},
  {matClass: 'record_voice_over'},
  {matClass: 'redeem'},
  {matClass: 'remove_shopping_cart'},
  {matClass: 'reorder'},
  {matClass: 'report_problem'},
  {matClass: 'restore'},
  {matClass: 'restore_from_trash'},
  {matClass: 'restore_page'},
  {matClass: 'room'},
  {matClass: 'rounded_corner'},
  {matClass: 'rowing'},
  {matClass: 'schedule'},
  {matClass: 'search'},
  {matClass: 'settings'},
  {matClass: 'settings_applications'},
  {matClass: 'settings_backup_restore'},
  {matClass: 'settings_bluetooth'},
  {matClass: 'settings_brightness'},
  {matClass: 'settings_cell'},
  {matClass: 'settings_ethernet'},
  {matClass: 'settings_input_antenna'},
  {matClass: 'settings_input_component'},
  {matClass: 'settings_input_composite'},
  {matClass: 'settings_input_hdmi'},
  {matClass: 'settings_input_svideo'},
  {matClass: 'settings_overscan'},
  {matClass: 'settings_phone'},
  {matClass: 'settings_power'},
  {matClass: 'settings_remote'},
  {matClass: 'settings_voice'},
  {matClass: 'shop'},
  {matClass: 'shop_two'},
  {matClass: 'shopping_basket'},
  {matClass: 'shopping_cart'},
  {matClass: 'speaker_notes'},
  {matClass: 'speaker_notes_off'},
  {matClass: 'spellcheck'},
  {matClass: 'stars'},
  {matClass: 'store'},
  {matClass: 'subject'},
  {matClass: 'supervised_user_circle'},
  {matClass: 'supervisor_account'},
  {matClass: 'swap_horiz'},
  {matClass: 'swap_horizontal_circle'},
  {matClass: 'swap_vert'},
  {matClass: 'swap_vertical_circle'},
  {matClass: 'tab'},
  {matClass: 'tab_unselected'},
  {matClass: 'text_rotate_up'},
  {matClass: 'text_rotate_vertical'},
  {matClass: 'text_rotation_down'},
  {matClass: 'text_rotation_none'},
  {matClass: 'theaters'},
  {matClass: 'thumb_down'},
  {matClass: 'thumb_up'},
  {matClass: 'thumbs_up_down'},
  {matClass: 'timeline'},
  {matClass: 'toc'},
  {matClass: 'today'},
  {matClass: 'toll'},
  {matClass: 'touch_app'},
  {matClass: 'track_changes'},
  {matClass: 'translate'},
  {matClass: 'trending_down'},
  {matClass: 'trending_flat'},
  {matClass: 'trending_up'},
  {matClass: 'turned_in'},
  {matClass: 'turned_in_not'},
  {matClass: 'update'},
  {matClass: 'verified_user'},
  {matClass: 'vertical_split'},
  {matClass: 'view_agenda'},
  {matClass: 'view_array'},
  {matClass: 'view_carousel'},
  {matClass: 'view_column'},
  {matClass: 'view_day'},
  {matClass: 'view_headline'},
  {matClass: 'view_list'},
  {matClass: 'view_module'},
  {matClass: 'view_quilt'},
  {matClass: 'view_stream'},
  {matClass: 'view_week'},
  {matClass: 'visibility'},
  {matClass: 'visibility_off'},
  {matClass: 'voice_over_off'},
  {matClass: 'watch_later'},
  {matClass: 'work'},
  {matClass: 'work_off'},
  {matClass: 'work_outline'},
  {matClass: 'youtube_searched_for'},
  {matClass: 'zoom_in'},
  {matClass: 'zoom_out'},
  {matClass: 'alternate_email'},
  {matClass: 'business'},
  {matClass: 'call'},
  {matClass: 'call_end'},
  {matClass: 'call_made'},
  {matClass: 'call_merge'},
  {matClass: 'call_missed'},
  {matClass: 'call_missed_outgoing'},
  {matClass: 'call_received'},
  {matClass: 'call_split'},
  {matClass: 'cancel_presentation'},
  {matClass: 'cell_wifi'},
  {matClass: 'chat'},
  {matClass: 'chat_bubble'},
  {matClass: 'chat_bubble_outline'},
  {matClass: 'clear_all'},
  {matClass: 'comment'},
  {matClass: 'contact_mail'},
  {matClass: 'contact_phone'},
  {matClass: 'contacts'},
  {matClass: 'dialer_sip'},
  {matClass: 'dialpad'},
  {matClass: 'domain_disabled'},
  {matClass: 'email'},
  {matClass: 'forum'},
  {matClass: 'import_contacts'},
  {matClass: 'import_export'},
  {matClass: 'invert_colors_off'},
  {matClass: 'list_alt'},
  {matClass: 'live_help'},
  {matClass: 'location_off'},
  {matClass: 'location_on'},
  {matClass: 'mail_outline'},
  {matClass: 'message'},
  {matClass: 'mobile_screen_share'},
  {matClass: 'no_sim'},
  {matClass: 'pause_presentation'},
  {matClass: 'phone'},
  {matClass: 'phonelink_erase'},
  {matClass: 'phonelink_lock'},
  {matClass: 'phonelink_ring'},
  {matClass: 'phonelink_setup'},
  {matClass: 'portable_wifi_off'},
  {matClass: 'present_to_all'},
  {matClass: 'ring_volume'},
  {matClass: 'rss_feed'},
  {matClass: 'screen_share'},
  {matClass: 'sentiment_satisfied_alt'},
  {matClass: 'speaker_phone'},
  {matClass: 'stay_current_landscape'},
  {matClass: 'stay_current_portrait'},
  {matClass: 'stay_primary_landscape'},
  {matClass: 'stay_primary_portrait'},
  {matClass: 'stop_screen_share'},
  {matClass: 'swap_calls'},
  {matClass: 'textsms'},
  {matClass: 'unsubscribe'},
  {matClass: 'voicemail'},
  {matClass: 'vpn_key'},
  {matClass: '4k'},
  {matClass: 'add_to_queue'},
  {matClass: 'airplay'},
  {matClass: 'album'},
  {matClass: 'art_track'},
  {matClass: 'av_timer'},
  {matClass: 'branding_watermark'},
  {matClass: 'call_to_action'},
  {matClass: 'closed_caption'},
  {matClass: 'control_camera'},
  {matClass: 'equalizer'},
  {matClass: 'explicit'},
  {matClass: 'fast_forward'},
  {matClass: 'fast_rewind'},
  {matClass: 'featured_play_list'},
  {matClass: 'featured_video'},
  {matClass: 'fiber_dvr'},
  {matClass: 'fiber_manual_record'},
  {matClass: 'fiber_new'},
  {matClass: 'fiber_pin'},
  {matClass: 'fiber_smart_record'},
  {matClass: 'forward_10'},
  {matClass: 'forward_30'},
  {matClass: 'forward_5'},
  {matClass: 'games'},
  {matClass: 'hd'},
  {matClass: 'hearing'},
  {matClass: 'high_quality'},
  {matClass: 'library_add'},
  {matClass: 'library_books'},
  {matClass: 'library_music'},
  {matClass: 'loop'},
  {matClass: 'mic'},
  {matClass: 'mic_none'},
  {matClass: 'mic_off'},
  {matClass: 'missed_video_call'},
  {matClass: 'movie'},
  {matClass: 'music_video'},
  {matClass: 'new_releases'},
  {matClass: 'not_interested'},
  {matClass: 'note'},
  {matClass: 'pause'},
  {matClass: 'pause_circle_filled'},
  {matClass: 'pause_circle_outline'},
  {matClass: 'play_arrow'},
  {matClass: 'play_circle_filled'},
  {matClass: 'play_circle_outline'},
  {matClass: 'playlist_add'},
  {matClass: 'playlist_add_check'},
  {matClass: 'playlist_play'},
  {matClass: 'queue'},
  {matClass: 'queue_music'},
  {matClass: 'queue_play_next'},
  {matClass: 'radio'},
  {matClass: 'recent_actors'},
  {matClass: 'remove_from_queue'},
  {matClass: 'repeat'},
  {matClass: 'repeat_one'},
  {matClass: 'replay'},
  {matClass: 'replay_10'},
  {matClass: 'replay_30'},
  {matClass: 'replay_5'},
  {matClass: 'shuffle'},
  {matClass: 'skip_next'},
  {matClass: 'skip_previous'},
  {matClass: 'slow_motion_video'},
  {matClass: 'snooze'},
  {matClass: 'sort_by_alpha'},
  {matClass: 'stop'},
  {matClass: 'subscriptions'},
  {matClass: 'subtitles'},
  {matClass: 'surround_sound'},
  {matClass: 'video_call'},
  {matClass: 'video_label'},
  {matClass: 'video_library'},
  {matClass: 'videocam'},
  {matClass: 'videocam_off'},
  {matClass: 'volume_down'},
  {matClass: 'volume_mute'},
  {matClass: 'volume_off'},
  {matClass: 'volume_up'},
  {matClass: 'add'},
  {matClass: 'add_box'},
  {matClass: 'add_circle'},
  {matClass: 'add_circle_outline'},
  {matClass: 'archive'},
  {matClass: 'backspace'},
  {matClass: 'ballot'},
  {matClass: 'block'},
  {matClass: 'clear'},
  {matClass: 'create'},
  {matClass: 'delete_sweep'},
  {matClass: 'drafts'},
  {matClass: 'file_copy'},
  {matClass: 'filter_list'},
  {matClass: 'flag'},
  {matClass: 'font_download'},
  {matClass: 'forward'},
  {matClass: 'gesture'},
  {matClass: 'how_to_reg'},
  {matClass: 'how_to_vote'},
  {matClass: 'inbox'},
  {matClass: 'link'},
  {matClass: 'link_off'},
  {matClass: 'low_priority'},
  {matClass: 'mail'},
  {matClass: 'markunread'},
  {matClass: 'move_to_inbox'},
  {matClass: 'next_week'},
  {matClass: 'outlined_flag'},
  {matClass: 'redo'},
  {matClass: 'remove'},
  {matClass: 'remove_circle'},
  {matClass: 'remove_circle_outline'},
  {matClass: 'reply'},
  {matClass: 'reply_all'},
  {matClass: 'report'},
  {matClass: 'report_off'},
  {matClass: 'save'},
  {matClass: 'save_alt'},
  {matClass: 'select_all'},
  {matClass: 'send'},
  {matClass: 'sort'},
  {matClass: 'text_format'},
  {matClass: 'unarchive'},
  {matClass: 'undo'},
  {matClass: 'waves'},
  {matClass: 'weekend'},
  {matClass: 'where_to_vote'},
  {matClass: 'access_alarm'},
  {matClass: 'access_alarms'},
  {matClass: 'access_time'},
  {matClass: 'add_alarm'},
  {matClass: 'add_to_home_screen'},
  {matClass: 'airplanemode_active'},
  {matClass: 'airplanemode_inactive'},
  {matClass: 'battery_alert'},
  {matClass: 'battery_charging_full'},
  {matClass: 'battery_full'},
  {matClass: 'battery_std'},
  {matClass: 'battery_unknown'},
  {matClass: 'bluetooth'},
  {matClass: 'bluetooth_connected'},
  {matClass: 'bluetooth_disabled'},
  {matClass: 'bluetooth_searching'},
  {matClass: 'brightness_auto'},
  {matClass: 'brightness_high'},
  {matClass: 'brightness_low'},
  {matClass: 'brightness_medium'},
  {matClass: 'data_usage'},
  {matClass: 'developer_mode'},
  {matClass: 'devices'},
  {matClass: 'dvr'},
  {matClass: 'gps_fixed'},
  {matClass: 'gps_not_fixed'},
  {matClass: 'gps_off'},
  {matClass: 'graphic_eq'},
  {matClass: 'location_disabled'},
  {matClass: 'location_searching'},
  {matClass: 'mobile_friendly'},
  {matClass: 'mobile_off'},
  {matClass: 'network_cell'},
  {matClass: 'network_wifi'},
  {matClass: 'nfc'},
  {matClass: 'screen_lock_landscape'},
  {matClass: 'screen_lock_portrait'},
  {matClass: 'screen_lock_rotation'},
  {matClass: 'screen_rotation'},
  {matClass: 'sd_storage'},
  {matClass: 'settings_system_daydream'},
  {matClass: 'signal_cellular_4_bar'},
  {matClass: 'signal_cellular_alt'},
  {matClass: 'signal_cellular_connected_no_internet_4_bar'},
  {matClass: 'signal_cellular_no_sim'},
  {matClass: 'signal_cellular_null'},
  {matClass: 'signal_cellular_off'},
  {matClass: 'signal_wifi_4_bar'},
  {matClass: 'signal_wifi_4_bar_lock'},
  {matClass: 'signal_wifi_off'},
  {matClass: 'storage'},
  {matClass: 'usb'},
  {matClass: 'wallpaper'},
  {matClass: 'widgets'},
  {matClass: 'wifi_lock'},
  {matClass: 'wifi_tethering'},
  {matClass: 'add_comment'},
  {matClass: 'attach_file'},
  {matClass: 'attach_money'},
  {matClass: 'bar_chart'},
  {matClass: 'border_all'},
  {matClass: 'border_bottom'},
  {matClass: 'border_clear'},
  {matClass: 'border_color'},
  {matClass: 'border_horizontal'},
  {matClass: 'border_inner'},
  {matClass: 'border_left'},
  {matClass: 'border_outer'},
  {matClass: 'border_right'},
  {matClass: 'border_style'},
  {matClass: 'border_top'},
  {matClass: 'border_vertical'},
  {matClass: 'bubble_chart'},
  {matClass: 'drag_handle'},
  {matClass: 'format_align_center'},
  {matClass: 'format_align_justify'},
  {matClass: 'format_align_left'},
  {matClass: 'format_align_right'},
  {matClass: 'format_bold'},
  {matClass: 'format_clear'},
  {matClass: 'format_color_fill'},
  {matClass: 'format_color_reset'},
  {matClass: 'format_color_text'},
  {matClass: 'format_indent_decrease'},
  {matClass: 'format_indent_increase'},
  {matClass: 'format_italic'},
  {matClass: 'format_line_spacing'},
  {matClass: 'format_list_bulleted'},
  {matClass: 'format_list_numbered'},
  {matClass: 'format_list_numbered_rtl'},
  {matClass: 'format_paint'},
  {matClass: 'format_quote'},
  {matClass: 'format_shapes'},
  {matClass: 'format_size'},
  {matClass: 'format_strikethrough'},
  {matClass: 'format_textdirection_l_to_r'},
  {matClass: 'format_textdirection_r_to_l'},
  {matClass: 'format_underlined'},
  {matClass: 'functions'},
  {matClass: 'highlight'},
  {matClass: 'insert_chart'},
  {matClass: 'insert_chart_outlined'},
  {matClass: 'insert_comment'},
  {matClass: 'insert_drive_file'},
  {matClass: 'insert_emoticon'},
  {matClass: 'insert_invitation'},
  {matClass: 'insert_link'},
  {matClass: 'insert_photo'},
  {matClass: 'linear_scale'},
  {matClass: 'merge_type'},
  {matClass: 'mode_comment'},
  {matClass: 'monetization_on'},
  {matClass: 'money_off'},
  {matClass: 'multiline_chart'},
  {matClass: 'notes'},
  {matClass: 'pie_chart'},
  {matClass: 'publish'},
  {matClass: 'scatter_plot'},
  {matClass: 'score'},
  {matClass: 'short_text'},
  {matClass: 'show_chart'},
  {matClass: 'space_bar'},
  {matClass: 'strikethrough_s'},
  {matClass: 'table_chart'},
  {matClass: 'text_fields'},
  {matClass: 'title'},
  {matClass: 'vertical_align_bottom'},
  {matClass: 'vertical_align_center'},
  {matClass: 'vertical_align_top'},
  {matClass: 'wrap_text'},
  {matClass: 'attachment'},
  {matClass: 'cloud'},
  {matClass: 'cloud_circle'},
  {matClass: 'cloud_done'},
  {matClass: 'cloud_download'},
  {matClass: 'cloud_off'},
  {matClass: 'cloud_queue'},
  {matClass: 'cloud_upload'},
  {matClass: 'create_new_folder'},
  {matClass: 'folder'},
  {matClass: 'folder_open'},
  {matClass: 'folder_shared'},
  {matClass: 'cast'},
  {matClass: 'cast_connected'},
  {matClass: 'computer'},
  {matClass: 'desktop_mac'},
  {matClass: 'desktop_windows'},
  {matClass: 'developer_board'},
  {matClass: 'device_hub'},
  {matClass: 'device_unknown'},
  {matClass: 'devices_other'},
  {matClass: 'dock'},
  {matClass: 'gamepad'},
  {matClass: 'headset'},
  {matClass: 'headset_mic'},
  {matClass: 'keyboard'},
  {matClass: 'keyboard_arrow_down'},
  {matClass: 'keyboard_arrow_left'},
  {matClass: 'keyboard_arrow_right'},
  {matClass: 'keyboard_arrow_up'},
  {matClass: 'keyboard_backspace'},
  {matClass: 'keyboard_capslock'},
  {matClass: 'keyboard_hide'},
  {matClass: 'keyboard_return'},
  {matClass: 'keyboard_tab'},
  {matClass: 'keyboard_voice'},
  {matClass: 'laptop'},
  {matClass: 'laptop_chromebook'},
  {matClass: 'laptop_mac'},
  {matClass: 'laptop_windows'},
  {matClass: 'memory'},
  {matClass: 'mouse'},
  {matClass: 'phone_android'},
  {matClass: 'phone_iphone'},
  {matClass: 'phonelink'},
  {matClass: 'phonelink_off'},
  {matClass: 'power_input'},
  {matClass: 'router'},
  {matClass: 'scanner'},
  {matClass: 'security'},
  {matClass: 'sim_card'},
  {matClass: 'smartphone'},
  {matClass: 'speaker'},
  {matClass: 'speaker_group'},
  {matClass: 'tablet'},
  {matClass: 'tablet_android'},
  {matClass: 'tablet_mac'},
  {matClass: 'toys'},
  {matClass: 'tv'},
  {matClass: 'videogame_asset'},
  {matClass: 'watch'},
  {matClass: 'add_a_photo'},
  {matClass: 'add_photo_alternate'},
  {matClass: 'add_to_photos'},
  {matClass: 'adjust'},
  {matClass: 'assistant'},
  {matClass: 'assistant_photo'},
  {matClass: 'audiotrack'},
  {matClass: 'blur_circular'},
  {matClass: 'blur_linear'},
  {matClass: 'blur_off'},
  {matClass: 'blur_on'},
  {matClass: 'brightness_1'},
  {matClass: 'brightness_2'},
  {matClass: 'brightness_3'},
  {matClass: 'brightness_4'},
  {matClass: 'brightness_5'},
  {matClass: 'brightness_6'},
  {matClass: 'brightness_7'},
  {matClass: 'broken_image'},
  {matClass: 'brush'},
  {matClass: 'burst_mode'},
  {matClass: 'camera'},
  {matClass: 'camera_alt'},
  {matClass: 'camera_front'},
  {matClass: 'camera_rear'},
  {matClass: 'camera_roll'},
  {matClass: 'center_focus_strong'},
  {matClass: 'center_focus_weak'},
  {matClass: 'collections'},
  {matClass: 'collections_bookmark'},
  {matClass: 'color_lens'},
  {matClass: 'colorize'},
  {matClass: 'compare'},
  {matClass: 'control_point'},
  {matClass: 'control_point_duplicate'},
  {matClass: 'crop'},
  {matClass: 'crop_16_9'},
  {matClass: 'crop_3_2'},
  {matClass: 'crop_5_4'},
  {matClass: 'crop_7_5'},
  {matClass: 'crop_din'},
  {matClass: 'crop_free'},
  {matClass: 'crop_landscape'},
  {matClass: 'crop_original'},
  {matClass: 'crop_portrait'},
  {matClass: 'crop_rotate'},
  {matClass: 'crop_square'},
  {matClass: 'dehaze'},
  {matClass: 'details'},
  {matClass: 'edit'},
  {matClass: 'exposure'},
  {matClass: 'exposure_neg_1'},
  {matClass: 'exposure_neg_2'},
  {matClass: 'exposure_plus_1'},
  {matClass: 'exposure_plus_2'},
  {matClass: 'exposure_zero'},
  {matClass: 'filter'},
  {matClass: 'filter_1'},
  {matClass: 'filter_2'},
  {matClass: 'filter_3'},
  {matClass: 'filter_4'},
  {matClass: 'filter_5'},
  {matClass: 'filter_6'},
  {matClass: 'filter_7'},
  {matClass: 'filter_8'},
  {matClass: 'filter_9'},
  {matClass: 'filter_9_plus'},
  {matClass: 'filter_b_and_w'},
  {matClass: 'filter_center_focus'},
  {matClass: 'filter_drama'},
  {matClass: 'filter_frames'},
  {matClass: 'filter_hdr'},
  {matClass: 'filter_none'},
  {matClass: 'filter_tilt_shift'},
  {matClass: 'filter_vintage'},
  {matClass: 'flare'},
  {matClass: 'flash_auto'},
  {matClass: 'flash_off'},
  {matClass: 'flash_on'},
  {matClass: 'flip'},
  {matClass: 'gradient'},
  {matClass: 'grain'},
  {matClass: 'grid_off'},
  {matClass: 'grid_on'},
  {matClass: 'hdr_off'},
  {matClass: 'hdr_on'},
  {matClass: 'hdr_strong'},
  {matClass: 'hdr_weak'},
  {matClass: 'healing'},
  {matClass: 'image'},
  {matClass: 'image_aspect_ratio'},
  {matClass: 'image_search'},
  {matClass: 'iso'},
  {matClass: 'landscape'},
  {matClass: 'leak_add'},
  {matClass: 'leak_remove'},
  {matClass: 'lens'},
  {matClass: 'linked_camera'},
  {matClass: 'looks'},
  {matClass: 'looks_3'},
  {matClass: 'looks_4'},
  {matClass: 'looks_5'},
  {matClass: 'looks_6'},
  {matClass: 'looks_one'},
  {matClass: 'looks_two'},
  {matClass: 'loupe'},
  {matClass: 'monochrome_photos'},
  {matClass: 'movie_creation'},
  {matClass: 'movie_filter'},
  {matClass: 'music_note'},
  {matClass: 'music_off'},
  {matClass: 'nature'},
  {matClass: 'nature_people'},
  {matClass: 'navigate_before'},
  {matClass: 'navigate_next'},
  {matClass: 'palette'},
  {matClass: 'panorama'},
  {matClass: 'panorama_fish_eye'},
  {matClass: 'panorama_horizontal'},
  {matClass: 'panorama_vertical'},
  {matClass: 'panorama_wide_angle'},
  {matClass: 'photo'},
  {matClass: 'photo_album'},
  {matClass: 'photo_camera'},
  {matClass: 'photo_filter'},
  {matClass: 'photo_library'},
  {matClass: 'photo_size_select_actual'},
  {matClass: 'photo_size_select_large'},
  {matClass: 'photo_size_select_small'},
  {matClass: 'picture_as_pdf'},
  {matClass: 'portrait'},
  {matClass: 'remove_red_eye'},
  {matClass: 'rotate_90_degrees_ccw'},
  {matClass: 'rotate_left'},
  {matClass: 'rotate_right'},
  {matClass: 'shutter_speed'},
  {matClass: 'slideshow'},
  {matClass: 'straighten'},
  {matClass: 'style'},
  {matClass: 'switch_camera'},
  {matClass: 'switch_video'},
  {matClass: 'tag_faces'},
  {matClass: 'texture'},
  {matClass: 'timelapse'},
  {matClass: 'timer'},
  {matClass: 'timer_10'},
  {matClass: 'timer_3'},
  {matClass: 'timer_off'},
  {matClass: 'tonality'},
  {matClass: 'transform'},
  {matClass: 'tune'},
  {matClass: 'view_comfy'},
  {matClass: 'view_compact'},
  {matClass: 'vignette'},
  {matClass: 'wb_auto'},
  {matClass: 'wb_cloudy'},
  {matClass: 'wb_incandescent'},
  {matClass: 'wb_iridescent'},
  {matClass: 'wb_sunny'},
  {matClass: '360'},
  {matClass: 'add_location'},
  {matClass: 'atm'},
  {matClass: 'beenhere'},
  {matClass: 'category'},
  {matClass: 'compass_calibration'},
  {matClass: 'departure_board'},
  {matClass: 'directions'},
  {matClass: 'directions_bike'},
  {matClass: 'directions_boat'},
  {matClass: 'directions_bus'},
  {matClass: 'directions_car'},
  {matClass: 'directions_railway'},
  {matClass: 'directions_run'},
  {matClass: 'directions_subway'},
  {matClass: 'directions_transit'},
  {matClass: 'directions_walk'},
  {matClass: 'edit_attributes'},
  {matClass: 'edit_location'},
  {matClass: 'ev_station'},
  {matClass: 'fastfood'},
  {matClass: 'flight'},
  {matClass: 'hotel'},
  {matClass: 'layers'},
  {matClass: 'layers_clear'},
  {matClass: 'local_activity'},
  {matClass: 'local_airport'},
  {matClass: 'local_atm'},
  {matClass: 'local_bar'},
  {matClass: 'local_cafe'},
  {matClass: 'local_car_wash'},
  {matClass: 'local_convenience_store'},
  {matClass: 'local_dining'},
  {matClass: 'local_drink'},
  {matClass: 'local_florist'},
  {matClass: 'local_gas_station'},
  {matClass: 'local_grocery_store'},
  {matClass: 'local_hospital'},
  {matClass: 'local_hotel'},
  {matClass: 'local_laundry_service'},
  {matClass: 'local_library'},
  {matClass: 'local_mall'},
  {matClass: 'local_movies'},
  {matClass: 'local_offer'},
  {matClass: 'local_parking'},
  {matClass: 'local_pharmacy'},
  {matClass: 'local_phone'},
  {matClass: 'local_pizza'},
  {matClass: 'local_play'},
  {matClass: 'local_post_office'},
  {matClass: 'local_printshop'},
  {matClass: 'local_see'},
  {matClass: 'local_shipping'},
  {matClass: 'local_taxi'},
  {matClass: 'map'},
  {matClass: 'money'},
  {matClass: 'my_location'},
  {matClass: 'navigation'},
  {matClass: 'near_me'},
  {matClass: 'not_listed_location'},
  {matClass: 'person_pin'},
  {matClass: 'person_pin_circle'},
  {matClass: 'pin_drop'},
  {matClass: 'place'},
  {matClass: 'rate_review'},
  {matClass: 'restaurant'},
  {matClass: 'restaurant_menu'},
  {matClass: 'satellite'},
  {matClass: 'store_mall_directory'},
  {matClass: 'streetview'},
  {matClass: 'subway'},
  {matClass: 'terrain'},
  {matClass: 'traffic'},
  {matClass: 'train'},
  {matClass: 'tram'},
  {matClass: 'transfer_within_a_station'},
  {matClass: 'transit_enterexit'},
  {matClass: 'trip_origin'},
  {matClass: 'zoom_out_map'},
  {matClass: 'apps'},
  {matClass: 'arrow_back'},
  {matClass: 'arrow_back_ios'},
  {matClass: 'arrow_downward'},
  {matClass: 'arrow_drop_down'},
  {matClass: 'arrow_drop_down_circle'},
  {matClass: 'arrow_drop_up'},
  {matClass: 'arrow_forward'},
  {matClass: 'arrow_forward_ios'},
  {matClass: 'arrow_left'},
  {matClass: 'arrow_right'},
  {matClass: 'arrow_upward'},
  {matClass: 'cancel'},
  {matClass: 'check'},
  {matClass: 'chevron_left'},
  {matClass: 'chevron_right'},
  {matClass: 'close'},
  {matClass: 'expand_less'},
  {matClass: 'expand_more'},
  {matClass: 'first_page'},
  {matClass: 'fullscreen'},
  {matClass: 'fullscreen_exit'},
  {matClass: 'last_page'},
  {matClass: 'menu'},
  {matClass: 'more_horiz'},
  {matClass: 'more_vert'},
  {matClass: 'refresh'},
  {matClass: 'subdirectory_arrow_left'},
  {matClass: 'subdirectory_arrow_right'},
  {matClass: 'unfold_less'},
  {matClass: 'unfold_more'},
  {matClass: 'adb'},
  {matClass: 'airline_seat_flat'},
  {matClass: 'airline_seat_flat_angled'},
  {matClass: 'airline_seat_individual_suite'},
  {matClass: 'airline_seat_legroom_extra'},
  {matClass: 'airline_seat_legroom_normal'},
  {matClass: 'airline_seat_legroom_reduced'},
  {matClass: 'airline_seat_recline_extra'},
  {matClass: 'airline_seat_recline_normal'},
  {matClass: 'bluetooth_audio'},
  {matClass: 'confirmation_number'},
  {matClass: 'disc_full'},
  {matClass: 'drive_eta'},
  {matClass: 'enhanced_encryption'},
  {matClass: 'event_available'},
  {matClass: 'event_busy'},
  {matClass: 'event_note'},
  {matClass: 'folder_special'},
  {matClass: 'live_tv'},
  {matClass: 'mms'},
  {matClass: 'more'},
  {matClass: 'network_check'},
  {matClass: 'network_locked'},
  {matClass: 'no_encryption'},
  {matClass: 'ondemand_video'},
  {matClass: 'personal_video'},
  {matClass: 'phone_bluetooth_speaker'},
  {matClass: 'phone_callback'},
  {matClass: 'phone_forwarded'},
  {matClass: 'phone_in_talk'},
  {matClass: 'phone_locked'},
  {matClass: 'phone_missed'},
  {matClass: 'phone_paused'},
  {matClass: 'power'},
  {matClass: 'power_off'},
  {matClass: 'priority_high'},
  {matClass: 'sd_card'},
  {matClass: 'sms'},
  {matClass: 'sms_failed'},
  {matClass: 'sync'},
  {matClass: 'sync_disabled'},
  {matClass: 'sync_problem'},
  {matClass: 'system_update'},
  {matClass: 'tap_and_play'},
  {matClass: 'time_to_leave'},
  {matClass: 'tv_off'},
  {matClass: 'vibration'},
  {matClass: 'voice_chat'},
  {matClass: 'vpn_lock'},
  {matClass: 'wc'},
  {matClass: 'wifi'},
  {matClass: 'wifi_off'},
  {matClass: 'ac_unit'},
  {matClass: 'airport_shuttle'},
  {matClass: 'all_inclusive'},
  {matClass: 'beach_access'},
  {matClass: 'business_center'},
  {matClass: 'casino'},
  {matClass: 'child_care'},
  {matClass: 'child_friendly'},
  {matClass: 'fitness_center'},
  {matClass: 'free_breakfast'},
  {matClass: 'golf_course'},
  {matClass: 'hot_tub'},
  {matClass: 'kitchen'},
  {matClass: 'meeting_room'},
  {matClass: 'no_meeting_room'},
  {matClass: 'pool'},
  {matClass: 'room_service'},
  {matClass: 'rv_hookup'},
  {matClass: 'smoke_free'},
  {matClass: 'smoking_rooms'},
  {matClass: 'spa'},
  {matClass: 'check_box'},
  {matClass: 'check_box_outline_blank'},
  {matClass: 'indeterminate_check_box'},
  {matClass: 'radio_button_checked'},
  {matClass: 'radio_button_unchecked'},
  {matClass: 'star'},
  {matClass: 'star_border'},
  {matClass: 'star_half'},
  {matClass: 'add_alert'},
  {matClass: 'error'},
  {matClass: 'error_outline'},
  {matClass: 'notification_important'},
  {matClass: 'warning'},
  {matClass: 'cake'},
  {matClass: 'domain'},
  {matClass: 'group'},
  {matClass: 'group_add'},
  {matClass: 'location_city'},
  {matClass: 'mood'},
  {matClass: 'mood_bad'},
  {matClass: 'notifications'},
  {matClass: 'notifications_active'},
  {matClass: 'notifications_none'},
  {matClass: 'notifications_off'},
  {matClass: 'notifications_paused'},
  {matClass: 'pages'},
  {matClass: 'party_mode'},
  {matClass: 'people'},
  {matClass: 'people_outline'},
  {matClass: 'person'},
  {matClass: 'person_add'},
  {matClass: 'person_outline'},
  {matClass: 'plus_one'},
  {matClass: 'poll'},
  {matClass: 'public'},
  {matClass: 'school'},
  {matClass: 'sentiment_dissatisfied'},
  {matClass: 'sentiment_satisfied'},
  {matClass: 'sentiment_very_dissatisfied'},
  {matClass: 'sentiment_very_satisfied'},
  {matClass: 'share'},
  {matClass: 'thumb_down_alt'},
  {matClass: 'thumb_up_alt'},
  {matClass: 'whatshot'},
];
